import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { NotificationModel } from "./notification.model";
import { NotificationService } from "./notification.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../shared/dummy.component';
import { consts } from '../../consts';
import { ReconciliationService } from '../conciliation/reconciliation.service';
import * as FileSaver from 'file-saver';
import { Utils } from '../../shared/utils';

@Component({
    selector: 'convfact-notification-list',
    templateUrl: './notification-list.component.html',
    styleUrls: ['./notification-list.component.css'],
    standalone: false
})

export class NotificationListComponent implements OnInit {

  constructor(
    private router: Router,
    private notificationService: NotificationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    public reconciliationService: ReconciliationService,
  ) { }

  dataSource: NotificationModel[];
  empty = false;
  ready = false;
  selectedUids: string[] = [];

  get hasSelected(): boolean { return this.selectedUids.length > 0; }
  get unreadCount(): number { return this.dataSource?.filter(n => !n.readed).length ?? 0; }

  toggleSelect(uid: string): void {
    const idx = this.selectedUids.indexOf(uid);
    if (idx === -1) this.selectedUids.push(uid);
    else this.selectedUids.splice(idx, 1);
  }

  isSelected(uid: string): boolean { return this.selectedUids.includes(uid); }

  toggleSelectAll(): void {
    if (this.selectedUids.length === this.dataSource.length) this.selectedUids = [];
    else this.selectedUids = this.dataSource.map(n => n.uid);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 4000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  changeStatus(uid) {
    this.notificationService.changeStatus(uid).then(
      data => {
        if (data == consts.STATUS_OK)
          this.dummy.redirectTo(this.router.url);
        else
          this.displayInfo("No ha sido posible cambiar el estado de las notificaciones. Intentelo más tarde");
      }
    );
  }

  delete(uid) {
    this.notificationService.delete(uid).then(
      data => {
        if (data == consts.STATUS_OK)
          this.dummy.redirectTo(this.router.url);
        else
          this.displayInfo("No ha sido posible cambiar eliminar las notificaciones. Intentelo más tarde");
      }
    );
  }

  goTo(uid) {
    const url = this.dataSource.find(f => f.uid == uid).url;
    if (url != "") {
      this.router.navigateByUrl(url);
    }
  }

  ngOnInit() {
    this.notificationService.getList().then(
      data => {
        this.dataSource = data;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.notificationService.updateUnreadCount(this.dataSource.filter(f => !f.readed).length);
        this.ready = true;
      }
    );
  }

  public isConciliationNotification(bodyText: string): boolean {
    const regex = /Se descargaron \d+ y se conciliaron \d+ transacciones/;

    // Comprobar si la cadena coincide con el patrón
    if (regex.test(bodyText)) {
      return true;
    }

    return false;
  }

  public downloadConciliationReport(notificationUid: string): void {

    this.reconciliationService.downloadExcelConciliationAutomaticReport(notificationUid)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName("Reporte_Conciliacion_automatica"));
      }).catch(err => {
        this.displayInfo('Ha ocurrido un error al descargar el fichero excel');
      });
  }

  public trackByIndex(i: number) { return i; }

}
